import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { thunk } from 'redux-thunk'
import createRootReducer from './reducers'

export const history = createBrowserHistory()

const enhancer = composeWithDevTools({
  trace: true,
  traceLimit: 25,
})(applyMiddleware(routerMiddleware(history), thunk))

const store = createStore(createRootReducer(history), enhancer)

export default store
